import { Component, Input } from '@angular/core'
import { MatToolbar } from '@angular/material/toolbar'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'toolbar-component',
	templateUrl: './Toolbar.Component.html',
	imports: [MatToolbar, NgStyle],
})
export class ToolbarComponent {
	@Input() public styles: { [key: string]: string | number }

	@Input() public color: 'primary' | 'warn'
}
